import {React} from "react";
import   "./styles.css";

import TextImage from "../Common/TextImage";
import ImageText from "../Common/ImageText"
import  Neighbors from "../images/carris.png"
import bao_bah from "../images/blackandorange_bettyandharry.jpg"
import bao_ed from "../images/blackandorange_entrydecor.jpeg"
import srar_ed from "../images/shamrockandroll_entrydecor.jpeg"
import srar_t from "../images/shamrockandroll_table.jpeg"



const Home = () => {

     return (
<div style={{background:'#eceff3f6'}}>
      <div  >
          <h1 className={'boldFancyHeadFontCenter'}>Welcome to the Kermis Ballroom Dance Club</h1>
          <h3 className='boldFancyHeadFontCenter3'>Formal Dinner and Ballroom Dance Club</h3>
          <div/>
            <div className={'blackBodyFontCenter'}>
              Kermis - A festive celebration characterized by much noisy merrymaking.
            </div>
          </div>
      <div>
     
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={Neighbors}
          myText="Welcome to the Kermis Club.|Let us share a little about ourselves and what we do.|We invite you to peruse our pages
          and to see how much fun a dinner and dance club can be."
            />
      </div>

      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <TextImage 
          selImage={bao_bah}
          myText="Each of our events is held in one of the Dallas areas beautiful country clubs.|Events are themed which allows us to add just a little more flair to air.
                  | Dressing to the theme is never required, but can add to the fun. "
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage=''
          myText="We even dress the club up a little to get into the spirit of the event"
            />
            </div>
            <div className="container" >
              <img src={bao_ed} style={{background:'#eceff3f6',padding:"20px"}}/>
              <img src={srar_ed} style={{background:'#eceff3f6',padding:"20px"}}/>
              <img src={srar_t} style={{background:'#eceff3f6',padding:"20px"}}/>
            </div>
      
          
        </div>
        </div>
     )
   };
   
   export default Home;